export default function NotFoundPage() {
  return (
    <div className="m-5">
      <h1>404 Not Found</h1>
      <p>So sorry.</p>
    </div>
  );
}
